import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { PaymentService, AuthService, ViewportService, ErrorHandlerService, ConfirmDialogModel, ConfirmDialogComponent } from 'epay-library';
import { IPaymentAccount } from 'epay-library/lib/features/common/models/payment/paymentaccount';
import { IEMPPaymentList } from 'epay-library/lib/features/employer/models/payment/achd/employerPaymentList';
import { IEMPPaymentCollection } from 'epay-library/lib/features/employer/models/payment/employerPaymentCollection';

@Component({
  selector: 'emp-payment-list-common',
  templateUrl: './emppayment-list-common.component.html'
})
export class EMPPaymentListCommonComponent implements OnInit {
  @Input() baseurl = '';
  @Input() secondaryIdAlias = '';
  @Output() deletePaymentEmitter = new EventEmitter<{
    sender: string;
    success: boolean;
    message: string;
    confirmationNumber: string;
  }>();

  isLoggedIn = false;

  scheduledpaymentheader: string[] = [
    'Next Payment Date',
    'Nickname',
    'Bank Name',
    'Account',
    'Amount',
    'Frequency',
    'Day',
    'Start Date',
    'Action',
  ];
  paymentheader: string[] = ['Full Name', 'FSR #', 'SSN', 'Amount'];
  paymentaccounts: IPaymentAccount[];
  paymentCollection: IEMPPaymentCollection[];
  scheduledpayments: IEMPPaymentList[];
  accountKeys: string[];
  usernumber: number;
  selectedAccountKey = '';
  errorMessage = '';
  message = '';
  deleteresult = '';
  isLoadingPayments = false;
  isMobile = false;

  confirmationTitle = '';
  confirmationMessage = '';
  confirmationNumber = '';
  goToPrimary = '';
  goToPrimaryUrl = '';
  openConfirmation = false;

  constructor(
    private paymentService: PaymentService,
    private authService: AuthService,
    private viewpointService: ViewportService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public snackbar: MatSnackBar,
    public toolip: MatTooltipModule
  ) {
    this.paymentaccounts = [];
    this.paymentCollection = [];
    this.scheduledpayments = [];
    this.accountKeys = [];
    this.usernumber = 0;
    this.message = '';
    this.deleteresult = '';
  }

  ngOnInit() {
    this.getPaymentList();

    this.viewpointService.IsMobile.subscribe((mobile) => {
      this.isMobile = mobile;
      if (this.isMobile) {
        this.scheduledpaymentheader = ['Date', 'Bank Name', 'Amount', 'Action'];
      } else
        this.scheduledpaymentheader = [
          'Next Payment Date',
          'Nickname',
          'Bank Name',
          'Account',
          'Amount',
          'Frequency',
          'Day',
          'Start Date',
          'Action',
        ];
    });

    if (this.secondaryIdAlias !== '') {
      this.paymentheader = [
        'Full Name',
        this.secondaryIdAlias,
        'SSN',
        'Amount',
      ];
    } else {
      this.secondaryIdAlias = 'FSR Number';
    }
  }

  getPaymentList() {
    const today: any = new Date();
    this.isLoadingPayments = true;
    this.paymentService.getPaymentAccounts(this.baseurl).subscribe({
      next: (accounts: any) => {
        if (accounts.length) {
          this.paymentaccounts = this.filterOldAccount(accounts);
          this.paymentaccounts.forEach((account) => {
            this.accountKeys.push(account.scheduledPaymentAccountKey);
            this.paymentService
              .getPayments(
                this.baseurl,
                account.scheduledPaymentAccountKey,
                false
              )
              .subscribe(
                (payments) => {
                  if (payments.length > 0) {
                    payments.forEach((sp) => {
                      const scheduledDate: any = new Date(sp.nextScheduledDate);
                      const diffDays = Math.floor(
                        (today - scheduledDate) / (1000 * 60 * 60 * 24)
                      );
                      if (Math.abs(diffDays) <= 2) {
                        sp.canDelete = false;
                      } else {
                        sp.canDelete = true;
                      }
                    });
                    this.scheduledpayments =
                      this.scheduledpayments.concat(payments);
                  }
                  this.scheduledpayments = this.scheduledpayments.sort((a, b) =>
                    a.nextScheduledDate > b.nextScheduledDate ? 1 : -1
                  );
                },
                (error) => {
                  this.isLoadingPayments = false;
                  this.errorMessage = error as any;
                  if (error.status !== 404) {
                    this.logError(error);
                    this.handleError(error.status);
                  }
                }
              );
          });
        }
      },
      error: (error: any) => {
        this.isLoadingPayments = false;
        this.errorMessage = error as any;
        this.logError(error);
        this.handleError(error.status);
      },
      complete: () => {
        this.isLoadingPayments = false;
      },
    });
  }

  filterOldAccount(accounts: IPaymentAccount[]) {
    return accounts.filter(
      (account) =>
        this.datePipe.transform(account.inactiveDate, 'yyyy-MM-dd') ===
        '9999-12-31'
    );
  }

  editpayment(payment: IEMPPaymentList) {
    this.router.navigateByUrl('employer/achd/payment', { state: payment });
  }

  deletepayment(payment: IEMPPaymentList) {
    const message = `Are you sure you want to delete this scheduled payment?`;
    const paymentName =
      payment.scheduleNickName.length > 0 ? payment.scheduleNickName : '';
    const paymentAmt = payment.amount;
    const paymentDate = this.datePipe.transform(
      payment.nextScheduledDate,
      'yyyy-MM-dd'
    )!;
    const paymentAcct = payment.accountNumberMasked;
    const dialogData = new ConfirmDialogModel(
      'Confirm Deleting Scheduled Payment',
      message,
      '',
      paymentAcct,
      paymentAmt,
      paymentDate,
      paymentName
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '600px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe({
      next: (dialogResult: any) => (this.deleteresult = dialogResult),
      error: (error: any) => console.log(error),
      complete: () => {
        if (this.deleteresult) {
          this.paymentService.deletePayment(this.baseurl, payment).subscribe({
            next: (success: any) => {
              for (let i = 0; i < this.scheduledpayments.length; i++) {
                if (
                  this.scheduledpayments[i].scheduledPaymentId ===
                  payment.scheduledPaymentId
                ) {
                  this.scheduledpayments.splice(i, 1);
                }
              }
              this.deletePaymentEmitter.emit({
                sender: 'ACHD Home',
                success: true,
                message: 'Your scheduled payment has been DELETED.',
                confirmationNumber: success.confirmationNumber,
              });
            },
            error: (error: any) => {
              this.errorMessage = error as any;
              this.logError(error);
              this.handleError(error.status);
            },
          });
        }
      },
    });
  }

  onDeleteComplete(confirmationNum: string) {
    this.confirmationNumber = confirmationNum;
    this.goToPrimaryUrl = 'employer/landing';
    this.goToPrimary = 'Home';
    this.openConfirmation = true;
  }

  openSnackBar(message: string, time: number, style: string) {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = time;
    config.panelClass = style;
    this.snackbar.open(message, '', config);
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}
